module.exports = __webpack_public_path__ + "images/videoCaseStudy-nivea-solution-videoOverlay.png?h=6567dcef036bcd345503ef50392c47bb";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-solution-videoOverlay.png
// module id = 2118
// module chunks = 12 15